import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { useTranslation } from 'react-i18next';
import { WSTableUserCreditLimitCheckbox } from '../WSTbaleUserCreditLimitCheckbox';
import { WSTableUserCreditLimitCheckboxTemplate } from '../template/WSTableUserCreditLimitsCheckboxTemplate';
import { CreditLimitRowWrapper } from './CreditLimitRowWrapper';

interface Props {
  users: DTO__workspace_user[];
}

export const WSTableUserCreditLimitsRowCheckboxes: React.FC<Props> = ({ users }) => {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  /*
   * RENDERS
   */
  function renderUserDisabledCheckboxes() {
    return users.map(user => {
      return (
        <span
          key={`limit-${user._id}-checkbox`}
          className={`${md('min-w-[40px] text-[12px]', 'min-w-[100px] max-w-[100px] h-[50px]')} flex items-center justify-center ${
            user.user_id == current_workspace_user.user_id ? 'border-r border-dashed border-component-item' : ''
          }`}
        >
          <WSTableUserCreditLimitCheckbox user={user} />
        </span>
      );
    });
  }

  /*
   * HTML
   */

  return (
    <CreditLimitRowWrapper borderType="border-dashed">
      <span className={`${md('min-w-[130px] text-[9px]', 'min-w-[220px]')} text-left`}>
        {t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_limit.row.button_enabled)}
      </span>
      <span
        key={`limit-template-checkbox`}
        className={`${md(
          'min-w-[40px] text-[12px]',
          'min-w-[100px] max-w-[100px] h-[50px]',
        )} border-r border-dashed border-component-item flex items-center justify-center`}
      >
        <WSTableUserCreditLimitCheckboxTemplate />
      </span>

      {renderUserDisabledCheckboxes()}
    </CreditLimitRowWrapper>
  );
};
